import { GeneralTable } from "@/shared/components/ui";
import { postRegenerarPdfIngreso, useFetchGetIngresarProducto } from "@/shared/actions/erp";
import { UseTableColumnsIngresoInventariable, useTableFilter, useTableServerSideFiltering, useUploadFile } from "@/shared/hooks";
import { Grid, IconButton } from "@mui/material";
import { IDataTrasladoInventario } from "@/shared/interfaces";
import { toast } from "react-toastify";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

export default function TableIngresoHistorialComponente() {

  const { columnBase } = UseTableColumnsIngresoInventariable();

  const {
    pagination,
    setPagination,
  } = useTableFilter();

  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } = useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;


  const {
    isLoading,
    data: dataIngresoInventariable,
    isRefetching,
  } = useFetchGetIngresarProducto({
    enabled: true,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      ...filterObject,
    }
  })

  const {
    descargarPdfDesdeurl
  } = useUploadFile()

  return (
    <Grid container spacing={2}>
      {/* <Grid item xs={12}>
        <CustomSearch
          onChange={onChangeFilter}
          value={globalFilter}
          text=""

          onChangeRangeDate={onChangeRangeDate}
          cleanFilter={cleanFilter}
        />
      </Grid> */}
      <Grid item xs={12}>
        {/* <GeneralTable<IDataTrasladoInventario>
          columns={columnBase}
          data={dataIngresoInventariable?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={dataIngresoInventariable?.data?.count}
          // // actions
          actionsColumnSize={120}
          // crud
          enableColumnActions={false}
          enableEditing={false}
          positionActionsColumn='first'

        /> */}

        <GeneralTable<IDataTrasladoInventario>
          columns={columnBase}
          data={dataIngresoInventariable?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={dataIngresoInventariable?.data.count}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          // crud
          canDelete={false}
          positionActionsColumn='first'
          canEdit={false}
          enableColumnActions={true}
          showCustomActionBtnSpace={true}
          enableManualFiltering={true}
          enableSorting={false}
          customActionBtnSpace={(value) => {
            return (
              <Grid container>
                <Grid item>
                  <IconButton onClick={async () => {

                    try {
                      const response: any = await postRegenerarPdfIngreso(value?.id_ingreso_inventario!)
                      const url = response?.data?.url_pdf ?? null

                      if (!url) {
                        toast.info('No existe documento. [404]')
                        return;
                      }

                      descargarPdfDesdeurl(url!, `INGRESO_INVENTARIO_${value.numero_referencia}`)

                    } catch (error) {
                      console.log(error);
                      
                      return toast.error("Error al generar el documento.")
                    }



                  }}>
                    <CloudDownloadIcon color="info" />
                  </IconButton>
                </Grid>

              </Grid>
            )
          }}
        />
      </Grid>
    </Grid>
  );



}